import React, { useState, useEffect } from 'react';
import api from '@api';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Standings.css'


function Standings() {
 const { user } = useAuth();
 const [teams, setTeams] = useState([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
  const fetchTeams = async () => {

   try {
    // 1️⃣ Get Active Season
    const seasonRes = await api.get(`/api/seasonsv2`);

    const activeSeason = seasonRes.data.seasons?.find(s => s.active);
    if (!activeSeason) return;

    // 2️⃣ Get Leagues with Teams
    const leaguesRes = await api.get(`/api/seasonsv2/${activeSeason.id}/leagues-with-teams-public`);

    const allTeams = leaguesRes.data.leagues?.flatMap(league =>
     league.teams?.map(team => ({
      ...team,
      leagueName: league.name,
      seasonName: activeSeason.name,
     })) || []
    );

    setTeams(allTeams || []);
   } catch (err) {
    console.error('Error fetching teams for FAB standings:', err);
   } finally {
    setLoading(false);
   }
  };

  fetchTeams();
 }, [user]);

 if (loading) return <div>Loading...</div>;
console.log(teams)
 const sortedTeams = [...teams]
  .map(team => ({
   ...team,
   winPercentage: team.wins + team.losses > 0
    ? (team.wins / (team.wins + team.losses)).toFixed(3)
    : '0.000',
  }))
  .sort((a, b) => {
   const aWinPct = parseFloat(a.winPercentage);
   const bWinPct = parseFloat(b.winPercentage);
   if (bWinPct !== aWinPct) return bWinPct - aWinPct;
   return a.losses - b.losses || b.wins - a.wins;
  });

 return (
  <div className="fab-standings-container">
   <h2 className="fab-standings-title">FAB Admin Standings View</h2>
   {sortedTeams.length > 0 ? (
    <table className="fab-standings-table">
     <thead>
      <tr className="fab-standings-head">
       <th>Position</th>
       <th>Team</th>
       <th>Captain</th>
       <th>League</th>
       <th>Wins</th>
       <th>Losses</th>
      </tr>
     </thead>
     <tbody>
      {sortedTeams.map((team, index) => (
       <tr key={team.id} className="fab-standings-row">
        <td>{index + 1}</td>
        <td>{team.name}</td>
        <td>{team.captain}</td>
        <td>{team.leagueName}</td>
        <td>{team.wins}</td>
        <td>{team.losses}</td>
       </tr>
      ))}
     </tbody>
    </table>
   ) : (
    <p>No teams found.</p>
   )}
  </div>
 );
 
}

export default Standings;
